import { Periods } from '@shared/utils/History/TFInfo';
import { HistoryMergerBasedByDay } from './HistoryMergerBasedByDay';
export class HistoryMergerWeek extends HistoryMergerBasedByDay {
    constructor(inputParams) {
        super(inputParams);
        this.firstDayOfWeek = 1; // Monday
        this.firstDayOfWeek = this.session.FirstDayOfWeek;
    }
    GetDaysInPeriod(dateTime) {
        let result = 0;
        for (let i = 0; i < this.GetCount(); i++) {
            result += 7;
        }
        return result;
    }
    IsStartPeriodDate(dateTime) {
        // id:118400  - first day of week is from server
        return dateTime.weekday % 7 === this.firstDayOfWeek; // Monday by default and // Sunday (7) -> 0
    }
    GetBasePeriod() {
        return Periods.WEEK;
    }
}
